import React from 'react';
import Calendar from 'react-calendar';
import styled, {css} from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';

export const StyledDatePicker = styled(Calendar)<{
  $view?: string;
}>`
  width: 100%;
  border: solid 1px ${colors.borderGray};
  background-color: #fff;
  position: absolute;
  top: 110%;
  left: 0;
  z-index: 10000;
  border-radius: 6px;
  overflow: hidden;
  border: solid 1px #191919;
  .react-calendar__tile {
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${minmax(20)};
  }
  .react-calendar__navigation {
    width: 100%;
    height: max(30px, min(3vw, 60px));
    position: absolute;
    /* display: flex; */
    /* align-items: center; */
    background-color: ${colors.lighterGray};
    border-radius: 6px;
  }
  .react-calendar__month-view__weekdays {
    height: max(30px, min(3vw, 60px));
  }
  .react-calendar__tile--active {
    color: ${colors.white};
  }

  .react-calendar__navigation button:disabled {
    border-radius: 6px;
  }

  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    border-radius: 6px;
  }
  .react-calendar__tile--now {
    background: transparent;
    color: black;
  }
  .react-calendar__tile--now:hover {
    background: #e6e6e6;
  }

  /* .react-calendar__tile--active {
      color: black;
    } */

  .react-calendar__navigation__label__labelText,
  .react-calendar__navigation__label__labelText--from {
    position: absolute;
    top: 50%;
    left: max(10px, min(1.2vw, 20px));
    transform: translate(0%, -50%);
    font-size: ${minmax(24)};
    line-height: max(12px, min(1.5vw, 24px));
  }
  // 날짜 옆 화살표
  .react-calendar__navigation__label__labelText--from::after {
    content: '';
    display: inline-block;
    width: max(12px, min(1.2vw, 24px));
    height: max(10px, min(1vw, 20px));
    margin-left: 8px;
    background-image: url('images/common/calendar_down_btn.png');
    background-repeat: no-repeat;
    background-size: contain;
    transform: translate(0%, 20%);
  }
  .react-calendar__month-view__weekdays {
    /* font-size: 30px; */
    /* height: max(34px, min(3.4vw, 64px)); */
  }
  .react-calendar__month-view__weekdays__weekday {
    font-size: ${minmax(20)};
    & > * {
      text-decoration: none;
    }
  }
  .react-calendar__month-view__days {
    font-size: ${minmax(20)};
  }
  .react-calendar__month-view__weekdays__weekday:first-child {
    color: red;
  }
  /* .react-calendar__month-view__weekdays__weekday
      .react-calendar__month-view__weekdays__weekday--weekend {
      color: red;
    } */
  .react-calendar__month-view__weekdays__weekday:last-child {
    color: blue;
  }
  .react-calendar__month-view__days__day--weekend {
    color: black;
  }
  .react-calendar__month-view__days {
    /* height: 22vh; */
  }
  .react-calendar__month-view__days .react-calendar__tile {
    margin: 0 !important;
  }
  abbr {
    font: unset;
    font-size: ${minmax(24)};
  }
  .react-calendar__navigation__arrow {
    min-width: fit-content;
    position: absolute;
    height: 100%;
    /* font-size: max(20px, min(2vw, 60px)); */
  }
  .react-calendar__navigation__prev-button {
    right: max(25px, min(2.6vw, 50px));
  }
  .react-calendar__navigation__next-button {
    right: max(5px, min(0.5vw, 10px));
    /* border-radius: 6px; */
  }
  .react-calendar__tile:disabled,
  .react-calendar__month-view__days__day--neighboringMonth {
    background-color: #fff;
    color: ${colors.whisper};
  }
  .react-calendar__tile,
  .react-calendar__month-view__weekdays__weekday {
    padding: max(12px, min(1vw, 24px));
    /* line-height: ; */
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus,
  .react-calendar__tile--active {
    background-color: ${colors.primary};
    border-radius: 100%;
    color: ${colors.white};
  }
  .react-calendar__year-view__months {
    padding-top: max(30px, min(3vw, 60px));
    > * {
      aspect-ratio: 1.4/1;
    }
  }

  ${(props: any) =>
    props.$view === 'decade' &&
    css`
      .react-calendar__decade-view__years {
        font-size: ${minmax(30)};
        padding-top: max(30px, min(3vw, 60px));
      }
      .react-calendar__decade-view__years__year {
        flex: 0 0 25% !important;
      }
    `}
`;

/**
 * 화살표 아이콘 컴포넌트
 * 이전/다음 버튼을 위한 화살표 아이콘을 표시합니다.
 * @param {{type: 'prev' | 'next'}} props - 화살표 아이콘 컴포넌트의 props
 * @param {'prev' | 'next'} props.type - 화살표 타입
 * @returns {JSX.Element} 화살표 아이콘 컴포넌트
 */
const ArrowIcon = ({type}: {type: 'prev' | 'next'}) => {
  return (
    <Arrow src={`images/common/calendar_${type}.png`} alt={`${type} button`} />
  );
};

/**
 * 이전 화살표 아이콘 생성 함수
 * 이전 버튼을 위한 화살표 아이콘을 생성합니다.
 * @returns {JSX.Element} 이전 화살표 아이콘
 */
export const prevArrowIcon = () => {
  return <ArrowIcon type="prev" />;
};

/**
 * 다음 화살표 아이콘 생성 함수
 * 다음 버튼을 위한 화살표 아이콘을 생성합니다.
 * @returns {JSX.Element} 다음 화살표 아이콘
 */
export const nextArrowIcon = () => {
  return <ArrowIcon type="next" />;
};

const Arrow = styled.img`
  width: max(12px, min(1.2vw, 22px));
`;
